import { useTranslation } from 'react-i18next';

export const useStrings = () => {
  const { t: translate } = useTranslation();

  return {
    rowSize: translate('flexible_reports_row_size', 'Row count'),
    fileSize: translate('flexible_reports_file_size', 'File size'),
    selectRequiredFields: translate(
      'flexible_reports_select_required_fields',
      'To estimate report size, select accounts, campaigns, metrics, and dimensions related to time and level of detail.'
    ),
    approachingThresholdWarning: translate(
      'flexible_reports_approaching_threshold_warning',
      'Your estimated report size is too large and report generation may fail. Try changing the date range, selecting fewer accounts, or applying specific filters.'
    ),
    overThresholdHeading: translate(
      'flexible_reports_over_threshold_warning',
      'Your estimated file size is too large and report generation will fail'
    ),
    overThresholdAlert: translate(
      'flexible_reports_over_threshold_alert',
      'Your estimated file size is too large and report generation will fail. Try changing the date range, selecting fewer accounts, or applying specific filters.'
    ),
    overThresholdBannerMessage: translate(
      'flexible_reports_over_threshold_banner_message',
      'Try changing the date range, selecting fewer accounts, or applying specific filters.'
    ),
    calculating: translate('flexible_reports_calculating', 'Calculating'),
    rowSizeOver1M: translate(
      'flexible_reports_over_million_records',
      'As per our estimation, this report may not open in certain applications because it includes more than 1M rows.'
    ),
    rowSizeOver1MApproachingThreshold: translate(
      'flexible_reports_over_million_records_approaching_threshold',
      'As per our estimation, this report may not open in certain applications because the file size is too large and it includes more than 1M rows.'
    ),
    loadingError: translate(
      'flexible_reports_cost_estimation_loading_error',
      'We encountered an unexpected error. Please try again or contact our support team if the issue continues.'
    )
  };
};
